import React from 'react';

export default class Page11 extends React.Component {

    _savePageStatus = (nextPage) => () => {

        this.props.handleChangeMainPage(nextPage)();

        if (this.props.incompletePage)
            this.props.savePageStatus()('HowToThinkAboutProblemsLaterally');
    }

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt wide_page">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">Example four</div>

                                            <p>The river water was only deep enough to reach the driver’s
                                                chest.</p>
                                            <div
                                                className="lightgreencontentbg keyquestionpadnew lightbgcenter">
                                                <div className="border_subtitle">Preference scenario answer
                                                    sheet
                                                </div>
                                                <p style={{paddingBottom: '5px !important'}}>The items needed
                                                    were door numbers. Each digit costs £2.</p>
                                                <div className="paraspace"><p>So the cost breakdown for the
                                                    four numbers required is as follows:</p></div>
                                                <ul className="greenbullet-list uiheading">
                                                    <li><p>There is 1 digit in 1 and this therefore costs
                                                        £2</p></li>
                                                    <li><p>There is 1 digit in 2 and this therefore costs
                                                        £2</p></li>
                                                    <li><p>There are 2 digits in 12 and this therefore costs
                                                        £4</p></li>
                                                    <li className="cntareap"><p>There are 3 digits in 144
                                                        and this therefore costs £6.</p></li>

                                                </ul>
                                            </div>
                                            <p></p>


                                            <div className="circle_title"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>Further Information
                                            </div>

                                            <p>If you found this tool useful then you are likely to find the
                                                following tools both insightful and relevant: </p>
                                            <div className="keyquestionpad">
                                                <ul className="greenbullet-list">
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToBeInnovative')}
                                                        className="link_color thought button-link-redirect">How to be
                                                        innovative</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToReframeProblems')}
                                                        className="link_color thought button-link-redirect">How to reframe
                                                        problems</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToFocusOnTheBiggerPicture')}
                                                        className="link_color thought button-link-redirect">How to focus on the
                                                        bigger picture</div></li>
                                                    <li><div
                                                        onClick={this._savePageStatus('HowToGetTheMostOutOfYourself')}
                                                        className="link_color thought button-link-redirect">How to get the most
                                                        out of yourself.</div></li>

                                                </ul>
                                            </div>
                                            <p></p>
                                            <div className="circle_title"><img
                                                src={require('@images/greendot.jpg')}
                                                alt=""/>REFERENCES
                                            </div>

                                            <ol className="testclass">
                                                <li><p className="further_info_content"> De Bono, E
                                                    (1970).<span
                                                        className="subtiltereg"> Lateral Thinking.</span> Penguin
                                                    Books.</p></li>
                                                <li><p className="further_info_content"> Myers,
                                                    I. &amp; Myers, P. (1995).<span className="subtiltereg"> Gifts Differing: Understanding Personality Type.</span> Mountain
                                                    View, CA: Davies-Black
                                                    Publishing.</p></li>
                                                <li><p className="further_info_content"><a
                                                    href="http://www.folj.com/lateral/fanciful.htm"
                                                    className="link_color thought"> http://www.folj.com/lateral/fanciful.htm</a>
                                                </p></li>
                                                <li><p className="further_info_content">Adapted from <a
                                                    href="http://www.folj.com/lateral/fanciful.htm"
                                                    className="link_color thought">http://www.folj.com/lateral/fanciful.htm</a>
                                                </p></li>
                                            </ol>

                                            <div className="left-btn">
                                                <div onClick={this.props.handleChangePage('Page10')}
                                                     className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this._savePageStatus('Thought')}
                                                    className="button-next-previous-done thought">Done
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}